// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/rate/index.css
// module id = 449
// module chunks = 32